import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import { useAtom } from 'jotai';
import { useNotification } from "../../context/NotificationContext";
import { NotificationType } from "../../enums/NotificationType";
import { docsRefreshAtom } from '../../atoms/managedocs/useDocsRefreshAtom';

import axios from "../../api/axios";
import config from '../../config/configJS';

const Uploader = ({ id }) => {

    const { showNotification } = useNotification();
    const [, setDocsRefresh] = useAtom(docsRefreshAtom);

    const [t, ] = useTranslation('global');
    const [files, setFiles] = useState([]);
    const [progress, setProgress] = useState({started: false, pc: 0 }); 

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        //accept: "application/pdf, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint,text/plain, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document ",
        onDrop: (acceptedFiles) => {
            setFiles(acceptedFiles);
          }
      });

    useEffect(()=> {
        setFiles([]);
        setProgress({ started: false, pc: 0 });
    },[id]);

    function handleUpload(filesToUpload = files) {
        if (progress.started) {
            return;
        }

        if (!filesToUpload?.length) {
            showNotification({ message: t('noFileSelected'), type: NotificationType.Error });
            return;
        }

        const formData = new FormData();
        filesToUpload.forEach((file) => {
            formData.append("files", file);
        });

        showNotification({ message: t('uploading'), type: NotificationType.Info });

        setProgress(prevState => {
            return {...prevState, started: true}
        })

        axios.post(config.endPoint + '/api/millai/SaveFile', formData, {
            onUploadProgress: (progressEvent) => { 
                setProgress(prevState => {
                    return {... prevState, pc: progressEvent.progress * 100 }
                });
            },
            headers: {
                "json": JSON.stringify({ "docsEnvId": id }),  
            },
            withCredentials: true
        })
        .then(res => {
            // offline priečinok odmietne obrázky a audio (vie ich len Document Intelligence)
            const rejected = res.data?.rejected || [];
            // (notifikácia je len jedna naraz -> pri odmietnutí ukáž iba túto hlášku)
            if (rejected.length) {
                showNotification({ message: `${t('uploadRejectedOffline')} ${rejected.join(', ')}`, type: NotificationType.Error });
            } else {
                showNotification({ message: t('uploadSuccess'), type: NotificationType.Info });
            }
            console.log(res.data);

            // Okamžite obnov zoznam dokumentov (nečakaj na 15s poll)
            setDocsRefresh(x => x + 1);

            setTimeout(() => {
                setFiles([]);
                setProgress({ started: false, pc: 0 }); 
            }, 1000);
        })
        .catch(err => {
            if (err.response?.status === 507) {
                // strážca disku: na serveri je málo miesta (časť súborov sa mohla uložiť -> obnov zoznam)
                showNotification({ message: t('uploadDiskLow'), type: NotificationType.Error });
                if (err.response.data?.saved?.length) {
                    setDocsRefresh(x => x + 1);
                }
            } else {
                showNotification({ message: t('uploadError'), type: NotificationType.Info });
            }
            console.error(err);
            setProgress({ started: false, pc: 0 });
        });
    }

    useEffect(() => {
        if (files.length > 0) {
            handleUpload(files);
        }
    }, [files]);

    return (
        <div className="uploader">
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              {isDragActive ?
                  <p className="upload-drop">
                    <span className="material-symbols-outlined drag-drop">
                        download
                    </span>
                    {t('dropFilesHere')}
                                        { progress.started && <progress className="upload-progress" max="100" value={progress.pc}></progress> }
                  </p> :
                  <p className="upload-msg">
                    <span className="material-symbols-outlined drag-drop">
                        upload_file
                    </span>
                    {t('dragNDrop')}
                                        { progress.started && <progress className="upload-progress" max="100" value={progress.pc}></progress> }
                  </p>
                }
            </div>
            <ul>
            {files.map((file) => (
                <li key={file.name}>{file.name} {file.type} {file.size} </li>
            ))}
            </ul>
            <button className="submit-button" onClick={() => handleUpload()}>{t('upload')}</button>
        </div>
    );
}

export default Uploader;
